export default {
  buttons: {
    save: 'Salvează',
  },
  error_messages: {
    product_unavailable: 'Epuizat!',
  },
};
